const wowApp = require('angular').module('wowApp.digitalpay');

const { paypalPaymentComponentDefinition } = require('./paypal-payment.component');

wowApp.component('wowPaypalPayment', paypalPaymentComponentDefinition);



// WEBPACK FOOTER //
// ./src/digitalpay/paypal/index.js